import request from '@/utils/request'


//查询
export function qlStoreLevelLesson(params) {
  return request({
    url: '/admin/level/lesson/qlLevelLesson',
    method: 'get',
    params: params
  })
}

export function newLevelLesson(data) {
  return request({
    url: '/admin/level/lesson/newLevelLesson',
    method: 'post',
    data: data
  })
}
//查询服务
export function lessonsList(params) {
  return request({
    url: '/admin/lessons/list',
    method: 'get',
    params: params
  })
}
export function updateLevelLesson(data) {
  return request({
    url: '/admin/level/lesson/updateLevelLesson',
    method: 'post',
    data: data
  })
}
export function delLevelLesson(params) {
  return request({
    url: '/admin/level/lesson/delLevelLesson',
    method: 'get',
    params: params
  })
}
//下线课程
export function offLine(data) {
  return request({
    url: '/admin/level/lesson/offLine',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/StoreLevelLesson.js